import { render } from "./group.vue?vue&type=template&id=271bae88&bindings={}"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"
script.render = render

export default script